export default __webpack_public_path__ + "static/media/penseive.c3363baf.jpg";